export default __webpack_public_path__ + "static/media/gldatabase_undertaking_final.e62b1138.pdf";